import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Noto Sans JP',
      'sans-serif'
    ].join(','),
    body3: {
      lineHeight: 2, // Set line spacing for body1
    },
    // Override specific typography settings if needed
    h1: {
      fontFamily: 'Noto Sans JP',
    },
    h2: {
      fontFamily: 'Noto Sans JP',
    },
    h3: {
      fontFamily: 'Noto Sans JP',
    },
    h4: {
      fontFamily: 'Noto Sans JP',
    },
    h5: {
      fontFamily: 'Noto Sans JP',
    },
    h6: {
      fontFamily: 'Noto Sans JP',
    },
    p: {
      fontFamily: 'Noto Sans JP',
    },
    a: {
      fontFamily: 'Noto Sans JP',
    },
    span: {
      fontFamily: 'Noto Sans JP',
    },
    div: {
      fontFamily: 'Noto Sans JP',
    },
    button: {
      fontFamily: 'Noto Sans JP',
      fontWeight: '400',
    },
  },
  palette: {
    primary: {
      main: '#CCAA65',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#877151',
    },
    customcolor: {
      main: '#7E223D',
    },
    blue: {
      main: '#16375A',
    },
    grey: {
      main: '#949494', // Change to your desired color
    },
    text: {
      grey: '#ffffff', // Change to your desired text color
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Noto Sans JP',
        },
        p: {
          fontFamily: 'Noto Sans JP',
        },
        a: {
          fontFamily: 'Noto Sans JP',
        },
        span: {
          fontFamily: 'Noto Sans JP',
        },
        div: {
          fontFamily: 'Noto Sans JP',
        },
        button: {
          fontFamily: 'Noto Sans JP',
          fontWeight: '400'
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: 'transparent', // Makes the asterisk invisible
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Noto Sans JP', // Apply font to Button
          fontWeight: '400'
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Noto Sans JP', // Apply font to ToggleButton
          fontWeight: '400'
        },
      },
      selected: {
        backgroundColor: '#CCAA65 !imporatant', // Change background color when selected
        color: '#fff', // Change text color when selected
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: '#ffffff !important',
          fontSize: '12px',
          fontFamily: 'Noto Sans JP', // Ensure font is applied to StepLabel
        },
        root: {
          '&.Mui-active': {
            color: '#ffffff !important',
          },
          '&.Mui-completed': {
            color: '#ffffff !important',
          },
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Default color
          '&.Mui-active': {
            color: '#ECE3BA', // Color for active step
          },
          '&.Mui-completed': {
            color: '#ffffff', // Color for completed step
          },
        },
        text: {
          fill: '#000000', // Text color inside the step icon
          '&.Mui-active': {
            fill: '#ffffff', // Text color for active step icon
          },
          '&.Mui-completed': {
            fill: '#ffffff', // Text color for completed step icon
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            fontSize: '14px', // Adjust this to your desired font size
            fontFamily: 'Noto Sans JP', // Ensure placeholder font is applied
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 40, // Set minHeight for the entire Tabs component
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#fff',
          background: 'linear-gradient(135deg, #CCAA65 0%, #a98248 100%)',
          borderRadius: '5px',
          width: 22,
          height: 22,
          right: 8,
          top: 'calc(50% - 11px)',
          padding: 2,
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          pointerEvents: 'none',
          transition: 'transform 0.2s, background 0.2s',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& .MuiSelect-select': {
            paddingRight: '38px !important',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#183859', // Default text color
          minHeight: 40,
          padding: '0 12px',
          fontFamily: 'Noto Sans JP', // Ensure placeholder font is applied
          fontWeight: '600',
          // '&.Mui-selected': {
          //   fontWeight: 600, // Apply bold only to selected tab
          // },
        },
      },
    },
    // MuiToggleButton: {
    //   styleOverrides: {
    //     root: {
    //       // General styling for the ToggleButton
    //       '&.Mui-selected': {
    //         color: '#fff', // Text color when active
    //         backgroundColor: '#CCAA65 !important', // Background color when active
    //         '&:hover': {
    //           backgroundColor: '#CCAA65 !important', // Background color on hover when active
    //         },
    //       },
    //       // Optionally add styles for non-selected state
    //       '&:not(.Mui-selected)': {
    //         color: '#000', // Text color when inactive
    //         backgroundColor: '#e0e0e0', // Background color when inactive
    //         '&:hover': {
    //           backgroundColor: '#c0c0c0', // Background color on hover when inactive
    //         },
    //       },
    //     },
    //   },
    // },
  },
});

export default theme;

